import React, { useState } from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMobileLayout from 'Hooks/useMobileLayout';
import fr from 'facet-rest';
import {
  FadeInBox,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedCommon/ExecuteSelectLoadingPage/FadeInBox';
import GoalStrategyDetailsContainer from 'Organisms/GoalStrategyOverviewSection/GoalStrategyDetailsContainer';
import TaxStrategyDetailsContainer from 'Organisms/GoalStrategyOverviewSection/TaxStrategyDetailsContainer';
import RoadmapExecutiveSummaryDetailsContainer from 'Organisms/GoalStrategyOverviewSection/RoadmapExecutiveSummaryDetailsContainer';
import GoalStrategyOverviewBasicInfoCard from './GoalStrategyOverviewBasicInfoCard';

// Initially, the overview page loads, which is a grid of all the scenario goals. When the user clicks 'view details'
// on one of the goals, we show the goal-specific detail page. When the user clicks the back button on that goal-specific
// detail page, we should the grid with all scenario goals again.

const DATA_CONTAINERS = {
  ProposalScenarioGoalStrategyDetail: GoalStrategyDetailsContainer,
  ProposalScenarioTaxStrategyDetails: TaxStrategyDetailsContainer,
  RoadmapExecutiveSummaryStep: RoadmapExecutiveSummaryDetailsContainer,
};

const getDataContainer = (type) => {
  const dataContainer = DATA_CONTAINERS[type];
  if (!dataContainer) {
    throw new Error(`Did not find a data container for resource type ${type}!`);
  }
  return dataContainer;
};

export const GoalStrategyOverviewSectionLayout = () => {
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();
  const [currentGoalDetailResource, setCurrentGoalDetailResource] = useState(null);

  const onBack = () => {
    setCurrentGoalDetailResource(null);
  };

  if (currentGoalDetailResource) {
    const DataContainerComponent = getDataContainer(currentGoalDetailResource.type());
    return (
      <DataContainerComponent currentGoalDetailResource={currentGoalDetailResource} onBack={onBack} />
    );
  }

  return (
    <FadeInBox>
      <FDStack direction={'column'} alignItems={'center'} spacing={5}>
        <MetaControlField attr={'title'} />
        <MetaControlField attr={'subtitle'} />
        <FDStack direction={isMobile ? 'column' : 'row'} spacing={3} wrap paddingY={4} width={'100%'} justifyContent={'center'}>
          {resource.attr('goalBasicInfo').resources().list().map((goal) => {
            return (
              <GoalStrategyOverviewBasicInfoCard
                title={goal.attr('title')}
                detailsRelationship={goal.withRelationship(fr.relationships.details.name,
                  (rel) => rel,
                  () => null)}
                setDetailsResource={setCurrentGoalDetailResource}
              />
            );
          })}
        </FDStack>
      </FDStack>
    </FadeInBox>
  );
};

export default GoalStrategyOverviewSectionLayout;
